<template>
  <div
    v-if="user"
    class="bg-white p-2"
  >
    <!-- Language Toggle -->
    <div class="d-flex justify-content-end mb-1">
      <b-button-group size="sm">
        <b-button
          :variant="selectedLanguage === 'en' ? 'primary' : 'outline-primary'"
          @click="selectedLanguage = 'en'"
        >
          EN
        </b-button>
        <b-button
          :variant="selectedLanguage === 'ar' ? 'primary' : 'outline-primary'"
          @click="selectedLanguage = 'ar'"
        >
          AR
        </b-button>
      </b-button-group>
    </div>

    <!-- Top user summary -->
    <div class="d-flex align-items-center mb-2">
      <b-avatar
        :src="user.photo"
        size="4rem"
        variant="light-primary"
        class="mr-1"
        rounded
      />
      <div>
        <h5 class="mb-25">
          {{ user.name }}
        </h5>
        <div class="text-muted small">
          <span v-if="user.role">{{ user.role }}</span>
          <span v-if="user.job_description">
            • {{ user.job_description }}
          </span>
        </div>
      </div>
    </div>

    <b-row>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="MailIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Email</span>
        </div>
        <div>{{ user.email }}</div>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="PhoneIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Phone</span>
        </div>
        <div>{{ user.phone }}</div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="MapPinIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Office</span>
        </div>
        <div>
          {{ user.office && user.office.name }}
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="BriefcaseIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Department</span>
        </div>
        <div v-if="user.department">
          <span v-if="user.department.title">
            <span v-if="selectedLanguage === 'en'">
              {{ user.department.title.en || user.department.title.ar }}
            </span>
            <span v-else>
              {{ user.department.title.ar || user.department.title.en }}
            </span>
          </span>
        </div>
      </b-col>

      <b-col
        cols="12"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="FileTextIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Department Description</span>
        </div>
        <div v-if="user.department && user.department.description">
          <span v-if="selectedLanguage === 'en'">
            {{ user.department.description.en || user.department.description.ar }}
          </span>
          <span v-else>
            {{ user.department.description.ar || user.department.description.en }}
          </span>
        </div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="CalendarIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Joined At</span>
        </div>
        <div>{{ user.joined_at }}</div>
      </b-col>

      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <div class="font-weight-bold small text-muted d-flex align-items-center">
          <feather-icon
            icon="ActivityIcon"
            :size="'15'"
            color="black"
            class="mr-1"
          />
          <span>Status</span>
        </div>
        <b-badge :variant="user.active === 1 ? 'success' : 'danger'">
          {{ user.active === 1 ? 'Active' : 'Not Active' }}
        </b-badge>
      </b-col>
    </b-row>

    <!-- Leave balances -->
    <div class="mt-2">
      <h6 class="mb-1 d-flex align-items-center">
        <feather-icon
          icon="LayersIcon"
          :size="'15'"
          color="black"
          class="mr-1"
        />
        <span>Leave Balances</span>
      </h6>
      <b-row>
        <b-col
          v-for="item in user.current_balance || []"
          :key="item.type"
          cols="6"
          class="mb-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-capitalize small text-muted">
              {{ item.type.replace('_', ' ') }}
            </span>
            <b-badge variant="light-primary">
              {{ item.balance }}
            </b-badge>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserSiteDetailsTab',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedLanguage: 'en',
    }
  },
}
</script>
